'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var ListItem = _interopDefault(require('@material-ui/core/ListItem'));
var Typography = _interopDefault(require('@material-ui/core/Typography'));
var CheckIcon = _interopDefault(require('@material-ui/icons/Check'));
var ListItemAvatar = _interopDefault(require('@material-ui/core/ListItemAvatar'));

var StyledMainTypography = styled__default(Typography)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  font-weight: ", ";\n"], ["\n  font-weight: ", ";\n"])), function (_a) {
    var read = _a.read;
    return (read ? '500' : '700');
});
var StyledMListItem = styled__default(ListItem)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  border-bottom: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  background-color: ", ";\n"], ["\n  border-bottom: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  background-color: ",
    ";\n"])), function (_a) {
    var selected = _a.selected;
    return selected ? '#F5F8FB' : 'white';
});
var StyledTimeTypography = styled__default(Typography)(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.8rem;\n"], ["\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.8rem;\n"])), function (_a) {
    var read = _a.read;
    return (read ? '#606D7E' : '#4C7CFD');
});
var StyledSubTypography = styled__default(Typography)(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.9rem;\n"], ["\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.9rem;\n"])), function (_a) {
    var read = _a.read;
    return (read ? '#606D7E' : 'black');
});
var StyledCheckIcon = styled__default(CheckIcon)(templateObject_5 || (templateObject_5 = tslib.__makeTemplateObject(["\n  font-size: 16px;\n  margin-bottom: -3px;\n  padding-right: 1px;\n"], ["\n  font-size: 16px;\n  margin-bottom: -3px;\n  padding-right: 1px;\n"])));
var StyledItemAvatar = styled__default(ListItemAvatar)(templateObject_6 || (templateObject_6 = tslib.__makeTemplateObject(["\n  margin-right: -15px;\n"], ["\n  margin-right: -15px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.StyledCheckIcon = StyledCheckIcon;
exports.StyledItemAvatar = StyledItemAvatar;
exports.StyledMListItem = StyledMListItem;
exports.StyledMainTypography = StyledMainTypography;
exports.StyledSubTypography = StyledSubTypography;
exports.StyledTimeTypography = StyledTimeTypography;
